import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HandleError } from '../../components/common/utils/handleError.component';
import { SessionStorageService } from "ngx-webstorage";
import { ClienteLogin, ClienteXCiudad, Cliente } from '../login/cliente_login';
import { timeInterval } from 'rxjs/operator/timeInterval';
import { fail } from 'assert';
import { checkNoChangesNode } from '@angular/core/src/view/view';
import { CompleterService, CompleterData, CompleterItem } from 'ng2-completer';
import { LocalData } from 'ng2-completer/services/local-data';
import { UtilService } from '../../components/common/utils/util.service';
import { ConsultaCarpeta, Carpeta, Archivo, CarpetasArchivo, BuscaArchivos } from '../../components/common/utils/entities/util_entity';
import { BoletinesService } from './boletines.service';
import { ConsultarUsuarioMasivos } from '../../components/common/utils/consultarUsuarioMasivos';


const swal = require("sweetalert2");
declare var jQuery: any;

@Component({
    selector: 'boletines',
    templateUrl: 'boletines.template.html'
})

export class BoletinesComponent implements OnInit {
    usuarioMasivos: Cliente;
    usuarioEmpresa: ClienteXCiudad;
    usuario: ClienteLogin;
    consulta: ConsultaCarpeta;
    carpetasArchivos: CarpetasArchivo;
    carpetas: Carpeta[];
    showLoader: string;
    showLoaderTabla: string;
    archivosGnerls: Archivo[];
    filterQuery: string;
    segundoNivel: boolean;
    tercerNivel: boolean;
    archivosXAseguradora: Archivo[];
    archivosXCliente: Archivo[];
    datosBusqueda: BuscaArchivos;
    datosBusquedaXCliente: BuscaArchivos;
    rutaArmada: string;
    nombreCliente: string;
    banderaMasivos: boolean;
    usuarioMasivosSeleccionado: Cliente;
    banderaAseg: boolean;


    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private handleError: HandleError,
        private boletinesService: BoletinesService,
        public utilsService: UtilService,
        public sesionStorageService: SessionStorageService,
        private completerService: CompleterService,
        private consultarMasivo: ConsultarUsuarioMasivos
    ) {
        this.carpetas = new Array<Carpeta>();
        this.archivosGnerls = new Array<Archivo>();
        this.carpetasArchivos = new CarpetasArchivo();
        this.segundoNivel = false;
        this.tercerNivel = false;
        this.archivosXAseguradora = new Array<Archivo>();
        this.archivosXCliente = new Array<Archivo>();
        this.datosBusqueda = new BuscaArchivos();
        this.datosBusquedaXCliente = new BuscaArchivos();
        this.rutaArmada = "";
        this.nombreCliente = "";
        this.usuario = new ClienteLogin();
        this.usuarioMasivosSeleccionado = new Cliente();
        this.banderaMasivos = false;
        this.banderaAseg = false;


    }

    ngOnInit(): void {
        this.consulta = new ConsultaCarpeta();
        this.showLoader = "sk-loading";
        try {
            this.usuario = JSON.parse(this.sesionStorageService.retrieve("usuario"));
            this.usuarioMasivosSeleccionado = JSON.parse(this.sesionStorageService.retrieve("usermasivos"));
        } catch (e) {
            this.usuario = this.sesionStorageService.retrieve("usuario");
            this.usuarioMasivosSeleccionado = this.sesionStorageService.retrieve("usermasivos");
        }
        try {
            this.usuarioEmpresa = JSON.parse(this.sesionStorageService.retrieve("usuarioempresa"));
        } catch (e) {
            this.usuarioEmpresa = this.sesionStorageService.retrieve("usuarioempresa");
        }
        if (this.usuarioEmpresa != null) {
            this.consulta.Carpeta = 2;
            this.consulta.Empresa = this.usuarioEmpresa;
            this.consulta.Masivos = null;
            this.datosBusquedaXCliente.Carpeta = 2;
            this.datosBusquedaXCliente.CodigoCiudad = this.consulta.Empresa.Ciudad;
            this.datosBusquedaXCliente.CodigoCliente = this.consulta.Empresa.CodigoCliente;

        }
        if (this.usuario.Masivos != null && this.usuarioMasivosSeleccionado == null) {
            this.usuarioMasivos = this.usuario.Masivos[0];
            if (this.usuario.Masivos != null)
                this.consultarMasivo.iniciarUsuarioMasivo();
            this.banderaMasivos = true;
            this.consulta.Carpeta = 2;
            this.consulta.Empresa = null;
            this.consulta.Masivos = this.usuarioMasivos;
            this.datosBusquedaXCliente.Carpeta = 2;
            this.datosBusquedaXCliente.CodigoCiudad = this.consulta.Masivos.Ciudad;
            this.datosBusquedaXCliente.CodigoCliente = this.consulta.Masivos.CodigoCliente;

        }
        if (this.usuarioEmpresa == null) {
            this.usuarioMasivos = this.usuarioMasivosSeleccionado;
            if (this.usuario.Masivos != null)
                this.consultarMasivo.iniciarUsuarioMasivo();
            this.banderaMasivos = true;
            this.consulta.Carpeta = 2;
            this.consulta.Empresa = null;
            this.consulta.Masivos = this.usuarioMasivos;
            this.datosBusquedaXCliente.Carpeta = 2;
            this.datosBusquedaXCliente.CodigoCiudad = this.consulta.Masivos.Ciudad;
            this.datosBusquedaXCliente.CodigoCliente = this.consulta.Masivos.CodigoCliente;
        }
        this.boletinesService.getCarpetasPorSegmento(this.consulta).subscribe(
            result => {
                this.carpetas = result;
                this.carpetas.forEach(a => {
                    a.ClaseIcono = "fa-folder";
                });
                this.showLoader = "";
            },
            error => {
                this.handleError.redirectUrl(error);
                this.showLoader = "";
            });


        this.boletinesService.getArchivosXCliente(this.datosBusquedaXCliente).subscribe(
            listado => {
                this.archivosXCliente = listado;
                this.archivosXCliente.forEach(a => {
                    if (a.Extension == "pdf")
                        a.TipoIcono = "fa-file-pdf-o";

                    if (a.Extension == "xls" || a.Extension == "xlsx")
                        a.TipoIcono = " fa-file-excel-o";

                    else
                        a.TipoIcono = "fa-file-text-o";
                });
                this.showLoader = "";
            },
            error => {
                this.handleError.redirectUrl(error);
                this.showLoader = "";
            });

        this.boletinesService.getCarpetasArchivosPorCarpeta(this.datosBusquedaXCliente).subscribe(
            listadoGnrl => {
                this.archivosGnerls = listadoGnrl;
                this.archivosGnerls.forEach(a => {
                    if (a.Extension == "pdf")
                        a.TipoIcono = " fa-file-pdf-o";

                    if (a.Extension == "xls" || a.Extension == "xlsx")
                        a.TipoIcono = " fa-file-excel-o";

                    else
                        a.TipoIcono = "fa-file-text-o";
                });
                this.showLoader = "";
            },
            error => {
                this.handleError.redirectUrl(error);
                this.showLoader = "";
            });

    }

    verSubCarpetas(carpeta: Carpeta) {
        this.rutaArmada = "";
        this.rutaArmada = "1_Segmentos\\" + carpeta.Codigo + "_" + carpeta.Nombre;
        this.segundoNivel = true;
        this.tercerNivel = false;
        this.showLoaderTabla = "sk-loading";
        this.carpetas.forEach(a => {
            a.ClaseIcono = "fa-folder"
        });
        carpeta.ClaseIcono = "fa-folder-open-o";
        this.consulta.CodSegmento = carpeta.Codigo;

        this.boletinesService.getCarpetasAsegArchivosPorSegmento(this.consulta).subscribe(
            result => {
                this.carpetasArchivos.Carpetas = result.Carpetas;
                this.carpetasArchivos.Archivos = result.Archivos;
                if (this.carpetasArchivos.Carpetas.length == 0)
                    this.banderaAseg = true;
                else
                    this.banderaAseg = false


                this.carpetasArchivos.Carpetas.forEach(a => {
                    a.ClaseIcono = "fa-folder";
                });
                this.carpetasArchivos.Archivos.forEach(a => {
                    if (a.Extension == "pdf")
                        a.TipoIcono = " fa-file-pdf-o";

                    if (a.Extension == "xls" || a.Extension == "xlsx")
                        a.TipoIcono = " fa-file-excel-o";

                    else
                        a.TipoIcono = "fa-file-text-o";

                    a.RestoRuta = this.rutaArmada;
                });
                this.showLoaderTabla = "";
            },
            error => {
                this.handleError.redirectUrl(error);
                this.showLoaderTabla = "";
            }
        );
    }

    verArchivosXAseguradora(carpeta: Carpeta) {
        this.tercerNivel = true;
        this.showLoaderTabla = "sk-loading";

        this.carpetasArchivos.Carpetas.forEach(a => {
            a.ClaseIcono = "fa-folder"
        });
        carpeta.ClaseIcono = "fa-folder-open-o";
        this.datosBusqueda.Carpeta = 2;
        this.datosBusqueda.RestoRuta = this.rutaArmada + "\\" + carpeta.Codigo + "_" + carpeta.Nombre;

        this.boletinesService.getCarpetasArchivosPorCarpeta(this.datosBusqueda).subscribe(
            result => {
                this.archivosXAseguradora = result;
                this.showLoaderTabla = "";
            },
            error => {
                this.handleError.redirectUrl(error);
                this.showLoaderTabla = "";
            }
        );
    }

    descargar(archivo: Archivo) {
        this.boletinesService.getArchivo(archivo).subscribe(
            result => {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.className = "hidden"
                let fileBlob = result.blob();
                let blob = null;
                if (archivo.Extension.toUpperCase() == "PDF") {
                    blob = new Blob([fileBlob], {
                        type: 'application/pdf'
                    });
                }
                if (archivo.Extension.toUpperCase() == "XLSX") {
                    blob = new Blob([fileBlob], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                }
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                if (archivo.Extension.toUpperCase() == "PDF") {
                    a.download = archivo.Nombre + ".pdf";
                }
                if (archivo.Extension.toUpperCase() == "XLSX") {
                    a.download = archivo.Nombre + ".xlsx";
                }
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    if (archivo.Extension.toUpperCase() == "XLSX") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".xlsx");
                    } else {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".pdf");
                    }
                }
                else {
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
                this.showLoader = "";
            },
            error => {
                this.handleError.redirectUrl(error);
            }
        );
    }

    descargarArchGnrls(archivo: Archivo) {
        this.boletinesService.getArchivoGnrl(archivo).subscribe(
            result => {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.className = "hidden"
                let fileBlob = result.blob();
                let blob = null;
                if (archivo.Extension.toUpperCase() == "PDF") {
                    blob = new Blob([fileBlob], {
                        type: 'application/pdf'
                    });
                }
                if (archivo.Extension.toUpperCase() == "XLSX") {
                    blob = new Blob([fileBlob], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                }
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                if (archivo.Extension.toUpperCase() == "PDF") {
                    a.download = archivo.Nombre + ".pdf";
                }
                if (archivo.Extension.toUpperCase() == "XLSX") {
                    a.download = archivo.Nombre + ".xlsx";
                }
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    if (archivo.Extension.toUpperCase() == "XLSX") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".xlsx");
                    } else {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".pdf");
                    }
                }
                else {
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
                this.showLoader = "";
            },
            error => {
                this.handleError.redirectUrl(error);
            }
        );
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/boletines/boletines.component.ts